import API from "../../Data/Domain/API";
import URL from "../../Data/Domain/URL";
import Storage from "../../Data/Domain/Storage";

export async function getCarbonCredits(params = {}) {
  const { userId, page = 0, limit = 25, ...extra } = params;

  try {
    const ownerId = userId || new Storage("id").getItem();

    const url = URL.setParams(
      URL.buildUrl(`owners/${ownerId}/nfts`),
      { page, limit, ...extra }
    );
    console.log("Fetching Carbon Credits from URL:", url);

    const response = await new API(url).get();
    console.log("Response from API:", response);
    return response;
  } catch (error) {
    throw error;
  }
}